module.exports = __webpack_public_path__ + "static/media/IconTemplates_-55.b021e38f.svg";